<div class="alertBoundaryContainer" [class.boundaryLoading]="isLoading">
  <ng-container *ngIf="!isLoading; else loading">
    <div class="actionbtnWrapper">
      <button
        color="accent"
        mat-icon-button
        [matTooltip]="'map.alertBoundaryControls.drawNewBoundary' | t"
        (click)="drawBoundary('pen')"
      >
        <sn-icon fontIcon="fa-pen-swirl" [fontSet]="isDrawing === 'pen' ? 'fas' : 'fal'"></sn-icon>
      </button>
      <button
        color="accent"
        mat-icon-button
        [matTooltip]="'map.alertBoundaryControls.drawNewPolygon' | t"
        (click)="drawBoundary('polygon')"
      >
        <sn-icon
          fontIcon="fa-draw-polygon"
          [fontSet]="isDrawing === 'polygon' ? 'fas' : 'fal'"
        ></sn-icon>
      </button>
      <!-- <button
        color="accent"
        mat-icon-button
        matTooltip="Draw new circle"
        (click)="drawBoundary('circle')"
      >
        <sn-icon
          fontIcon="fa-dot-circle"
          [fontSet]="isDrawing === 'circle' ? 'fas' : 'fal'"
        ></sn-icon>
      </button> -->
      <button
        [disabled]="!activeBoundary"
        color="accent"
        mat-icon-button
        [matTooltip]="'map.alertBoundaryControls.saveActiveBoundary' | t"
        (click)="saveBoundary()"
      >
        <sn-icon fontSet="fal" fontIcon="fa-floppy-disk"></sn-icon>
      </button>
      <button
        [disabled]="!activeBoundary"
        color="accent"
        mat-icon-button
        [matTooltip]="'map.alertBoundaryControls.centerActiveBoundary' | t"
        (click)="centerBoundary()"
      >
        <sn-icon fontSet="fal" fontIcon="fa-location-crosshairs"></sn-icon>
      </button>
      <button
        [disabled]="isLoading || !hasBoundary"
        color="accent"
        mat-icon-button
        [matTooltip]="'map.alertBoundaryControls.reloadSavedBoundary' | t"
        (click)="reload()"
      >
        <sn-icon fontSet="fal" fontIcon="fa-redo-alt"></sn-icon>
      </button>
      <button
        [disabled]="!hasBoundary || isDrawing"
        color="warn"
        mat-icon-button
        [matTooltip]="'map.alertBoundaryControls.deleteSavedBoundary' | t"
        (click)="removeBoundary()"
      >
        <sn-icon fontSet="fal" fontIcon="fa-trash-alt"></sn-icon>
      </button>
      <button color="warn" mat-icon-button [matTooltip]="'common.close' | t" (click)="closeControlsBar()">
        <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
      </button>
    </div>
    <div class="noBoundaryMsg" *ngIf="!hasBoundary && !showError">{{ 'map.alertBoundaryControls.noActiveBoundaryFound' | t }}</div>
    <div class="noBoundaryMsg" *ngIf="showError">
      {{ 'map.alertBoundaryControls.boundaryNotSavedCorrectly' | t }}
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="loadingWrapper">
      <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
      <button color="accent" mat-icon-button [matTooltip]="'map.alertBoundaryControls.reloadSavedBoundary' | t" (click)="reload()">
        <sn-icon fontSet="fal" fontIcon="fa-redo-alt"></sn-icon>
      </button>
      <button color="warn" mat-icon-button [matTooltip]="'common.close' | t" (click)="closeControlsBar()">
        <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
      </button>
    </div>
  </ng-template>
</div>
